import React from 'react';

export const initialValue = {
  isMenu: false,
  toggleMenu: (show: boolean) => {}
};

const Context = React.createContext(initialValue);

export default Context;